const xdownloaderConfig = {
  tableTitle: 'BELIMO Holding AG',
  tableSelector: '.ns-table-wrap',
  excludeTableSelector: 'div[data-tableid="Agenda"], div[data-tableid^="ESG_GRI_Content_Index"',
  downloadText: " ", //Can be empty if you want to use an icon instead
  mergeStrings: [],
  numFmt: (cell, cellIndex, rowIndex) => {
    if ((String(cell.value).replace(' ', '')).trim().match(/^[+-]?(\d*\.\d+|\d+\.\d*|\d+)$/) && !['2011', '2012', '2013', '2014', '2015', '2016', '2017', '2018', '2019', '2020', '2021', '2022', '2023', '2024', '2025'].includes((String(cell.value).replace(' ', '')).trim())) {
      cell.value = parseFloat(String(cell.value).trim().replace(' ', ''));
      if (String(cell.value).indexOf('.') > -1) {
        cell.numFmt = '#,##0.??';
      }
      else {
        cell.numFmt = '#,##0';
      }
      // console.log(cell._address, cell.value)
    }
  },
  tableCellFormatter: (h) => {
    if (!h || !h.innerHTML) return '';
    let cell = document.createElement('td');
    cell.innerHTML = h.innerHTML;
    let superscript = cell.querySelector('.superscript');
    let superscriptContent = '';
    if (superscript) {
      superscriptContent = '(' + superscript.innerText + ')';
      superscript.parentNode.removeChild(superscript);
    }

    let cellContent = '';
    let cellSpan = cell.querySelector('span');
    let cellSpans = cellSpan ? cellSpan.querySelectorAll('span') : [];
    if (cellSpans.length > 0) {
      cellSpans.forEach(span => {
        if(!/<span\b[^>]*>(.*?)<\/span>/i.test(span.innerHTML)) {
          cellContent += span.innerText
        }
      })
    } else {
      let paragraph = cell.querySelector('p');
      cellContent += paragraph?.innerText;
    }

    return  cellContent.match(/\b\d{4}(?:\s*,\s*\d{4})*\b/) ? cellContent :
    cellContent.replace(/'/g, '').replace(/’/g, '').replace(/–/g, '-').replace(/,/g, '.').replace(/–/g, '-').replace(/,/g, '.');
  },
  styles: [
    {
      class: 'ns-horizontal-left',
      border: {
        bottom: {
          style: 'thin',
          color: {
            argb: 'FF000000'
          }
        },
      },
    },
    {
      class: 'ns-horizontal-right',
      border: {
        bottom: {
          style: 'thin',
          color: {
            argb: 'FF000000'
          }
        },
      },
    },
    {
      class: 'ns-horizontal-center',
      border: {
        bottom: {
          style: 'thin',
          color: {
            argb: 'FF000000'
          }
        },
      },
    },
    {
      class: 'head_chf',
      font: {
        bold: true,
        color: {
          argb: 'FF000000'
        }
      },
      head: true,
      index: 10
    },
    {
      class: 'head',
      font: {
        bold: true
      },
      border: {
        bottom: {
          style: 'medium',
          color: {
            argb: 'FF000000'
          },
          index: 10
        },
      },
    },
    {
      class: 'bline_bold',
      font: {
        bold: true
      },
      border: {
        bottom: {
          style: 'medium',
          color: {
            argb: 'FF000000'
          },
        },
      },

    },
    {
      class: 'line_bold',
      font: {
        bold: true
      }
    },
    {
      class: 'noline',
      border: {
        bottom: {
          style: 'none'
        }
      }
    },
    {
      class: 'nl',
      border: {
        bottom: {
          style: 'none'
        }
      }
    },
    {
      class: 'ns-background-03',
      fill: {
        type: 'pattern',
        pattern: 'solid',
        fgColor: {
          argb: 'FFE7E7E7'
        }
      }
    }
  ]
};

export default xdownloaderConfig;
